




















































































































































import Vue from 'vue'
import { defaultPosterImage } from '@/helper/constants'
import CheckoutService from '@/services/CheckoutService'
import NewProductCard from '@/components/product/NewProductCard.vue'
import { getContactId } from '@/services'
import axios from 'axios'
import config from '@/config/index'
import { OfferType, CheckoutSourceType } from '@/models/Offer'
import { UpsellOfferType } from '@/models/UpsellOffer'
import PaymentModal from '@/components/checkout/PaymentModal.vue'
import { adminMode } from '@/helper/permission.helper'
import UISpinner from '@/components/common/UISpinner.vue'
import http from './../../http-common'
import BaseIcon from '@/components/svgicons/BaseIcon.vue'

export default Vue.extend({
  components: { NewProductCard, PaymentModal, UISpinner, BaseIcon },
  data() {
    return {
      defaultPosterImage,
      contact: {} as { [key: string]: any },
      showModal: false,
      UpsellOfferType,
      CheckoutSourceType,
      showThankYouMsg: false,
      location: {},
      loader: false,
      disableCheckoutBtn: false,
      paymentMethods: []
    }
  },
  beforeMount() {
    if (!this.newMobileScreens || !this.offer) {
      this.$router.push({
        name: 'library-v2'
      })
      return
    }
  },
  async mounted() {
    await this.fetchOfferData()
  },
  computed: {
    showPaymentForm(): boolean {
      return (
        !this.optin &&
        !this.showThankYouMsg &&
        !this.freeProduct &&
        !this.offerAlreadyPurchased
      )
    },
    freeProduct(): boolean {
      return this.offer.type === OfferType.free
    },
    isAdmin() {
      return adminMode()
    },
    offerDescription(): string {
      return this.offer.description
        ? this.offer.description.length > 130
          ? this.offer.description.substring(0, 130) + '...'
          : this.offer.description
        : ''
    },
    offer(): any {
      return this.$route.params.offer
    },
    upsellId(): any {
      return this.$route.params.upsellId
    },
    purchasedProductIds(): any {
      return this.$route.params.purchasedProductIds
    },
    checkoutCallback(): any {
      return this.$route.params.checkout
    },
    device() {
      return this.$store.getters.device
    },
    newMobileScreens(): boolean {
      return this.$store.getters.newMobileScreens
    }
  },
  methods: {
    orderConfirmation({ ct, previewUrl, upsellOfferId }) {
      this.showThankYouMsg = true
      setTimeout(() => {
        window.location.reload()
      }, 2000)
    },
    async fetchOfferData() {
      try {
        this.loader = true
        const response = await CheckoutService.findById(this.offer.id)
        if (response?.status === 200) {
          const { data } = response
          this.location = data.location
        }
        const contactId = getContactId()
        await axios
          .get(config.mainServerUrl + `/contact/membership/${contactId}`)
          .then(async response => {
            this.contact = response.data
          })

        if (this.contact.stripeCustomerId) {
          await this.fetchPaymentMethods()
        }
      } catch (e) {
        console.error(e)
      } finally {
        this.loader = false
      }
    },
    async fetchPaymentMethods() {
      try {
        const params: object = {
          stripeCustomerId: this.contact.stripeCustomerId,
          offerId: this.offer.id
        }
        console.log(params)
        const {
          data
        } = await http.get(
          `/locations/${this.offer.locationId}/stripe/payment-methods`,
          { params }
        )
        this.paymentMethods = data
      } catch (error) {
        console.error(error)
      }
    },
    async checkout() {
      if (this.isAdmin) {
        return
      }
      this.disableCheckoutBtn = true
      await this.checkContactPurchasedOffer()
      if (
        !this.optin &&
        !this.showThankYouMsg &&
        !this.freeProduct &&
        !this.offerAlreadyPurchased
      ) {
        this.showModal = true
      }
      this.disableCheckoutBtn = false
    },
    async checkContactPurchasedOffer() {
      const {
        data: { purchased, loginUrl }
      } = await CheckoutService.checkIfContactPurchasedOffer({
        contactId: this.contact.id,
        offerId: this.offer.id,
        locationId: this.offer.locationId
      })
      this.offerAlreadyPurchased = purchased
      if (this.offerAlreadyPurchased) {
        this.url = loginUrl
        return
      }
      await this.createLeadEntry()
      if (this.offer.type === OfferType.free) {
        await this.createFreePurchase()
      }
      this.disableSubmitBtn = false
      this.optin = false
    },
    async createFreePurchase() {
      const payload = {
        fingerprint: this.contact.fingerprint,
        locationId: this.contact.location_id,
        productType: 'offer',
        checkoutType: 'free'
      }

      await CheckoutService.checkout(this.offer.id, payload)
        .then(response => {
          this.showThankYouMsg = true
          const { ct, previewUrl } = response.data
          this.cToken = ct
          this.url = previewUrl
          this.showModal = true
          setTimeout(() => {
            window.location.reload()
          }, 2000)
        })
        .catch(error => {
          console.error(error)
          const errorMessage = error?.response?.data?.msg
          this.errMsg =
            errorMessage || 'Something went wrong, please try again!'
        })
    },
    async createLeadEntry() {
      const payload = {
        contactId: this.contact.id,
        locationId: this.contact.location_id,
        offerId: this.offer.id
      }
      await CheckoutService.leadTrack(payload)
    },
    backToLibrary() {
      this.$router.push({ name: 'library-v2' })
    }
  },
  watch: {
    device(oldDevice, newDevice) {
      if (newDevice === 'mobile') {
        this.$router.push({ name: 'library-v2' })
      }
    }
  }
})
